import { IconButton, Button } from '@mui/material';
import Modal from "react-bootstrap/Modal";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { isUserAdmin } from '../../actions/auth';
import CoreSpinner from '../../components/_core/CoreSpinner';
import EditIcon from '@mui/icons-material/Edit';
import { Delete } from '@mui/icons-material';
import { get, post, put, deleteItem } from '../../actions/api';
import {
    Card,
    CardHeader,
    CardBody,
    Col,
} from "reactstrap";
import { ThemeContext } from '../../contexts/ThemeContext';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';


const TemplateGridItem = ({ item, preview, setPreview }) => {
    const isAdmin = isUserAdmin();
    const [deleting, setDeleting] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const theme = React.useContext(ThemeContext);
    const isDark = theme.theme === "" ? true : false;
    const styles = {
        Container: {
            width: '300px',
            height: '403px',
            marginRight: '15px',
            marginLeft: '15px',
            marginTop: '25px',
            marginBottom: '25px',
            border: '0.5px solid #626262'
        },
        Card: {
            width: '300px',
            height: '52.96px',
            marginLeft: '0px',
            background: 'rgba(98, 98, 98, 0.2)',
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
        },
        Text: {
            color: isDark ? 'white' : 'black',
            fontSize: '17px',
        },
        DelIcon: {
            color: 'red',
            fontSize: 17,
            marginTop: '-8px',
            marginLeft: '-15px',
            marginRight: '5px',
            float: 'left'
        }
    }

    async function deleteTemp() {
        setDeleting(true);
        await deleteItem("/templates?id=" + item.id);
        setDeleting(false);
        setOpenModal(false);
        window.location.reload();
    };

    return (
        <>


            <Col md={"2.9"}

                style={styles.Container}>
                <Card>
                    <CardHeader
                        style={styles.Card}>
                        {isAdmin &&
                            <Modal style={{ marginTop: 100 }} show={openModal}>
                                <Modal.Header>
                                    {item.archived ?
                                        <Modal.Title style={{ color: "primary", marginBottom: 5 }}>Restore</Modal.Title>
                                        :
                                        <Modal.Title style={{ color: "red", marginBottom: 5 }}>Delete</Modal.Title>
                                    }

                                </Modal.Header>
                                <Modal.Body>
                                    Are you sure you want to  {item.archived ? "restore" : "eliminate"}:<br />
                                    <strong>{item.title}</strong>?<br />
                                </Modal.Body>
                                <Modal.Footer style={{ marginBottom: 25 }}>
                                    {deleting && <CoreSpinner loading={deleting} />}
                                    <Button style={{ marginLeft: "15px" }} color="primary" onClick={() => { setOpenModal(false) }}>
                                        Cancel
                                    </Button>
                                    {
                                        item.archived ?
                                            <Button color="primary" style={{ marginRight: "15px" }} onClick={deleteTemp}>
                                                Restore
                                            </Button>
                                            :
                                            <Button color="error" style={{ marginRight: "15px" }} onClick={deleteTemp}>
                                                Delete
                                            </Button>
                                    }

                                </Modal.Footer>
                            </Modal>
                        }
                        {/* <span style={{color:'red',float:'left',marginTop:'-5px',marginLeft:'-5px'}}>Delete</span> */}
                        {isAdmin &&
                            <IconButton onClick={() => { setOpenModal(true) }} title="Restore" color='error' style={styles.DelIcon}>
                                {item.archived ? <RestoreFromTrashIcon color='primary' /> : <Delete />}
                            </IconButton>
                        }
                        <h4 style={styles.Text}>{item.title}</h4>
                        {isAdmin ?
                            <>
                                <Link to={{ pathname: "/builder", state: { id: item.id, generate: true } }} style={{ fontWeight: 'bold', color: '#4083ed', fontSize: 13, float: 'right', marginTop: '-45px', marginRight: 8, textDecoration: 'none' }}>
                                    Generate Forms
                                </Link>
                                <IconButton title="Edit" style={{ fontSize: 17, marginTop: '-50px', float: 'right' }} component={Link} to={{ pathname: "/builder", state: { id: item.id } }} color="primary">
                                    <EditIcon />
                                </IconButton>
                            </>
                            :
                            <Link to={{ pathname: "/builder", state: { id: item.id } }} style={{ fontWeight: 'bold', color: '#4083ed', fontSize: 13, float: 'right', marginTop: '-40px', textDecoration: 'none' }}>
                                Generate Forms
                            </Link>
                        }

                    </CardHeader>
                    <CardBody onClick={() => { setPreview(item) }} style={{ overflow: 'hidden', padding: 0, height: '320px', cursor: 'pointer' }}>
                        <div style={{ transform: 'scale(0.4)', transformOrigin: 'top left', width: '250%', height: '750px', pointerEvents: 'none' }}>
                            <iframe title="Preview" srcDoc={item.template} style={{ width: "100%", height: "100%", backgroundColor: "white", border: "none" }} />
                        </div>
                    </CardBody>
                </Card>
            </Col>

        </>
    );

};

export default TemplateGridItem;